/**
 * This component sits in the nav bar.  If there are any pending partners / resellers, it renders are a badge with a number
 * otherwise it displays nothing.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import { Badge, Tooltip } from '@mui/material';


import { red } from '@mui/material/colors';


const abEnvironment = new AbEnvironment();

//defines how often to check for pending partners.
const notificationCheckTime = 60000;  

const VendorPendingActionIconQuery = graphql`
query VendorPendingActionIconQuery($accountId: UUID!) {
  allVppTs (condition: { vendorId: $accountId, visibility: 2}) {
    nodes {
      vppRTsByVppId (condition: { stage: 1 }) {
        totalCount
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    notificationbadge: {
      marginRight: 14,
      marginTop: 6,
      color: red[600]
    }
});

class VendorPendingActionIcon extends Component {

    constructor(props) {
      super(props);
   
      this.timer = null;
      this.auth = this.props.auth;
 
      this.state = {
        fetchCount: 0
      };  


    }

    componentDidMount() {
      if (this.timer === null) {
        //console.log('starting timer');
        this.timer = setInterval(() => this.checkEnvironmentAndQuery(), notificationCheckTime);
      }

   }
  
    componentWillUnmount() {
      //console.log('clearing timer');
      if (this.timer != null) {
        clearInterval(this.timer);
      }
      this.timer = null;
    }

    checkEnvironmentAndQuery() {
      
      //This does not call isAuthenticated for a reason.  We track user activity there 
      //and this should NOT count.
      let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      if (expiresAt !== null) {
        this.setState({fetchCount: this.state.fetchCount + 1});
      } else {
        clearInterval(this.timer);
        //this.auth.logout();
      }
    }


    render() {
      const classes = this.props.classes;
      //console.log("looking for pending resellers");

      //note this will render an empty notification icon when fetching to minimize flicker.
      //most components show a spinner but that is distracting in this case.
      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={VendorPendingActionIconQuery}
          variables={{accountId: abEnvironment.getUserAttribute("a_id"),
                      fetchCount: this.state.fetchCount}}
          render={({error, props})=> {
            if (error) {
              return <span></span>
            } else if (props) {
              // Determine total count.
              let totalCount = 0;

              if (props.allVppTs.nodes[0] && props.allVppTs.nodes[0].vppRTsByVppId.totalCount > 0) {
                totalCount = props.allVppTs.nodes[0].vppRTsByVppId.totalCount;
              }

              let title = '';
              if (totalCount > 0) {
                if (totalCount === 1) {
                  title = '1 pending partner';
                } else {
                  title = totalCount + ' pending partner'
                }
              }

              if (totalCount > 0) {
                return (
                  <span>
                    <Tooltip id="tooltip-pending" title={title} placement="top" style={{marginTop: -10}}>
                        <Badge 
                          className={classes.notificationbadge} 
                          badgeContent={totalCount} 
                          color="error"
                          overlap="circular"
                          max={9}
                          >
                        </Badge>
                    </Tooltip>
                        
                  </span>
                );
  
              } else {
                //return nothing if no pending resellers
                return (null);
              }
            }
            //return nothing if no query results to avoid flicker.
            return (null);
          }}
        />
      );
    }
}
  
VendorPendingActionIcon.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorPendingActionIcon);